<template>
    <div
        v-if="isComponentReady"
        :class="{ [`l-ss-c-search-popup-wrapper-inbuilt`]: !$configuration.isPopup }"
        class="l-ss-c-search-popup-wrapper">
        <div
            :class="{
                'l-ss-c-search-popup-wrapper-mask-hidden':
                    isShowAgeCheckPopup ||
                    store.state.ui.isCategoriesListVisible ||
                    showResultsMask ||
                    isFiltersOpened
            }"
            :style="zIndexPopup"
            class="l-ss-c-search-popup-wrapper-mask"
            @mousedown="mousedownClose"
            @click.self="onClickOutside">
            <div
                :class="{
                    [`l-ss-c-search-popup-is-opened-mobile-nav`]: showMobileNavigation,
                    [`l-ss-c-search-popup-is-loading`]: isLoading,
                    'l-ss-c-search-popup__shadow': $configuration.showInput,
                    ...wrapperClasses,
                }"
                class="l-ss-c-search-popup">
                <popup
                    v-if="$configuration.features.imageSearch"
                    :opened="openedPopup"
                    scroll-to-top-on-mobile
                    :title="$t('imageSearch.title')"
                    class="l-ss-c-search-popup-image-search-popup"
                    @close="() => toggleImageSearch(false)">
                    <image-search-container
                        @search="startSearchByImage"
                        v-on="imageSearchContainerEventListeners"/>
                </popup>

                <popup
                    v-if="$configuration.features.voiceSearch"
                    :opened="store.state.ui.isVoiceSearchActive"
                    scroll-to-top-on-mobile
                    class="l-ss-c-search-popup-voice-search-popup"
                    @close="toggleVoiceSearch(undefined, false)">
                    <voice-search-container :store="store"/>
                </popup>

                <div
                    class="l-ss-c-search-popup-content-wrapper"
                    :class="{
                        'l-ss-c-search-popup-content-wrapper-right-angles': isContentVisible,
                        'l-ss-c-search-popup-content-wrapper-with-result': isResultsVisible && totalItemsCount
                    }">
                    <div
                        v-if="$configuration.showInput"
                        :style="topSectionWrapperStyles"
                        class="l-ss-c-search-top-section-wrapper l-ss-c-search-popup-content-wrapper-child">
                        <div
                            :class="{ 'l-ss-c-search-popup-top-section-full-width': this.$configuration.completionsFullWidth }"
                            class="l-ss-c-search-popup-top-section">
                            <img
                                v-if="$configuration.logoSrc && !$screen.isMobile && logoAccess"
                                :src="$configuration.logoSrc"
                                @error="onLoadLogo()"
                                class="l-ss-c-search-popup-logo"
                                @click="emitSearchPopupClose">
                            <search-input
                                ref="searchInput"
                                :data-border-radius="$screen.isMobile === true"
                                :enable-image-search="$configuration.features.imageSearch"
                                :enable-voice-search="$configuration.features.voiceSearch"
                                :is-cart-available="$configuration.features.addToCartButton"
                                :is-loading="isLoading"
                                :show-actions="true"
                                :image="base64Image"
                                v-bind="$props"
                                v-on="searchInputEventListeners">
                                <template #prefix>
                                    <catalog
                                        v-if="!$screen.isMobile && $configuration.features.catalog && !base64Image"
                                        :categories="allCategoriesTree"
                                        :data-border-radius="true"
                                        :has-filters="hasFilters"
                                        :has-query="hasQuery"
                                        :is-loading="isCategoriesLoading"
                                        v-on="catalogEventListeners"/>
                                </template>
                            </search-input>
                            <button
                                v-if="$screen.isMobile || (!$screen.isMobile && iconClosePopup)"
                                class="l-ss-c-button l-ss-c-search-popup-close-button"
                                v-html="!$screen.isMobile && iconClosePopup ? iconClosePopup : $t('cancel')"
                                @click="onClickCloseButton">
                            </button>
                        </div>
                    </div>

                    <search-results-wrapper
                        :has-query="hasQuery"
                        :has-results="hasResults"
                        :store="store"
                        :search-state="searchState"
                        :query="query"
                        :total-items-count="totalItemsCount"
                        :is-results-visible="isResultsVisible"
                        :is-filters-block-visible="isFiltersBlockVisible"
                        :request-categories="requestCategories"
                        :results-category-id="resultsCategoryId"
                        :error-text-completions="errorTextCompletions"
                        :error-text-search="errorTextSearch"
                        :has-filters="hasFilters"
                        :has-loaded-once="hasLoadedOnce"
                        :show-results-mask="showResultsMask"
                        :is-completions-loading="isCompletionsLoading"
                        :is-search-loading="isSearchLoading"
                        :loading-by-filters="loadingByFilters"
                        :limit="limit"
                        :search-response="searchResponse"
                        :search-request-id="searchRequestId"
                        :skip="skip"
                        :offer-templates="offerTemplates"
                        :filter-items="filterItems"
                        :sort-by="sortBy"
                        :sort-dest="sortDest"
                        :currency-in-offers="currencyInOffers"
                        :filter-values="filterValues"
                        :from_completions="from_completions"
                        :all-categories-tree="allCategoriesTree"
                        :search="search"
                        :is-show-signature="isShowSignature"
                        :adult-permission-confirmed="adultPermissionConfirmed"
                        v-on="searchResultsWrapperEventListeners"/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { installPlugins } from '../core/plugins';
    import SearchInput from '../core/components/search-input/search-input.vue';
    import RootComponentMixin from '../core/mixins/root-component';
    import CompletionsMixin from '../core/mixins/completions';
    import SearchResultsMixin from '../core/mixins/search-results-mixin';
    import ImageSearchContainer from '../core/components/image-search-container';
    import iconClosePopup from '../core/assets/images/icons/close-popup.svg';
    import Popup from '../core/components/popup';
    import { getCookie } from '/src/core/helpers/cookies';
    import VoiceSearchContainer from '@/core/components/voice-search-container.vue';
    import Catalog from '@/core/components/catalog/catalog.vue';
    import SearchResultsWrapper from '@/core/components/search-results/search-results-wrapper.vue';
    import EventEmitterMixin from '../core/mixins/event-emitter';
    import {
        mapHandlers,
        commonOfferEventHandlers,
        commonSearchResultsWrapperEventHandlers,
    } from '../core/mixins/event-emitter';

    const POPOVER_Z_INDEX = 52;

    installPlugins();

    export default {
        components: {
            SearchResultsWrapper,
            Catalog,
            VoiceSearchContainer,
            SearchInput,
            ImageSearchContainer,
            Popup,
        },
        mixins: [
            RootComponentMixin,
            CompletionsMixin,
            SearchResultsMixin,
            EventEmitterMixin,
        ],
        provide: RootComponentMixin.provide,
        props: {
            ...CompletionsMixin.props,
            ...RootComponentMixin.props,
            ...SearchResultsMixin.props,
            from_completions: {
                type: String,
                default: '',
            },
            categoryId: {
                type: [String, Number],
                default: '',
            },
            query: {
                type: String,
                default: '',
            },
            params: {
                type: Array,
                default: () => ([]),
            },
            completions: {
                type: Array,
                required: false,
                default: () => ([]),
            },
            requestCategories: {
                type: Object,
                required: false,
                default: () => null,
            },
        },
        data() {
            return {
                localQueryParams: null,
                showMobileNavigation: false,
                showSearch: true,
                wrapperClickTarget: null,
                sectionImageKey: '',
                logoAccess: true,
                isShowCompletions: false,
            };
        },

        computed: {
            openedPopup() {
                return this.store.state.ui.isImageSearchVisible &&
                    this.store.state.ui.isNameWidgetActive.toUpperCase() === this.$root.$options.customElement.nodeName.toUpperCase();
            },
            ...CompletionsMixin.computed,
            ...RootComponentMixin.computed,
            ...SearchResultsMixin.computed,
            zIndexPopup() {
                return this.$configuration.isPopup ? { 'z-index': 999888 } : { 'z-index': 100 };
            },
            topSectionWrapperStyles() {
                return {
                    zIndex: this.isTopSectionOnFrontLayer ? POPOVER_Z_INDEX : 'initial',
                    backgroundColor: this.store.state.ui.isCompletionsVisible && !this.$screen.isMobile ?
                        'transparent' :
                        'inherit',
                };
            },
            isFiltersOpened() {
                return this.store.state.ui.isFiltersOpened;
            },
            showResultsMask() {
                return this.$screen.isMobile && this.isShowCompletions;
            },
            isContentVisible() {
                return !!(this.store.state.ui.isCategoriesListVisible ||
                    (!this.isResultsVisible && this.isOpenSearchByImageOrVoice));
            },
            isTopSectionOnFrontLayer() {
                return (this.store.state.ui.isCategoriesListVisible && !this.$screen.isMobile) || this.showCompletions;
            },
            iconClosePopup() {
                const closePopupIcon = this.$configuration.closePopupIcon;

                if (closePopupIcon) {
                    return typeof closePopupIcon !== 'string' ?
                        iconClosePopup :
                        closePopupIcon;
                }

                return null;
            },
            isCategoriesLoading() {
                return this.requestCategories ? this.requestCategories.isLoading : false;
            },
            isLoading() {
                return this.isCompletionsLoading || this.isSearchLoading || this.isCategoriesLoading;
            },
            allCategoriesTree() {
                return this.requestCategories ? this.requestCategories.categoriesTree : [];
            },
            isShowAgeCheckPopup() {
                return this.store.state.ui.isShowAgeCheckPopup;
            },
            isOpenSearchByImageOrVoice() {
                return this.store.state.ui.isImageSearchVisible || this.store.state.ui.isVoiceSearchActive;
            },
            base64Image() {
                return this.store.state.base64Image;
            },
            imageSearchContainerEventListeners() {
                return {
                    'image-search-button-select-file-click': value => this.$emit('image-search-button-select-file-click', value),
                    'image-search-use-correct-link-click': value => this.$emit('image-search-use-correct-link-click', value),
                    'image-search-use-incorrect-link-click': value => this.$emit('image-search-use-incorrect-link-click', value),
                    'image-search-button-search-click': value => this.$emit('image-search-button-search-click', value),
                };
            },
            catalogEventListeners() {
                return {
                    'change': this.emitNavigateCategory,
                    'toggle': this.onToggleCategories,
                    'button-everywhere-click': this.emitButtonEverywhereClick,
                    'rubricator-category-click': this.emitRubricatorCategoryClick,
                    'reset-filters': this.emitResetFilters,
                    'reset-query': this.emitResetQuery,
                };
            },
            searchInputEventListeners() {
                return {
                    ...mapHandlers(this, commonOfferEventHandlers),
                    'blur': args => this.onSearchInputAction('search-input-blur', args),
                    'change': args => this.onSearchInputAction('search-input-change', args),
                    'focus': args => this.onSearchInputAction('search-input-focus', args),
                    'keyUpEnter': params => this.onSearchInputAction('search-input-enter', params),
                    'toggle-image-picker': args => this.onSearchInputAction('toggle-image-picker', args),
                    'toggle-voice-search': (event, isActive) => this.toggleVoiceSearch(event, isActive),
                    'handle-search': args => this.onSearchInputAction('handle-search', args),
                    'reset-query': args => this.onSearchInputAction('reset-query', args),
                    'popup-close': args => this.onSearchInputAction('reset-query', args),
                    'autocomplete-search': this.onAutocompleteSearch,
                    'params-search': this.emitParamsSearch,
                    'search-input-change': this.emitSearchInputChange,
                    'offer-click': this.emitOfferClick,
                    'category-click': this.emitCategoryClick,
                    'special-offers-click': this.emitSpecialOffersClick,
                    'suggestions-click': this.emitSuggestionsClick,
                    'brand-click': this.emitBrandClick,
                    'history-click': this.emitBrandClick,
                    'popular-click': this.emitPopularClick,
                    'button-image-click': this.emitButtonImageClick,
                    'search-click': this.emitSearchClick,
                    'preview-tab-click': this.emitPreviewTabClick,
                    'delete-all-text': this.emitDeleteAllText,
                    'search-all': this.emitSearchAll,
                    'preview-show-all-click': this.emitPreviewShowAllClick,
                    'remove-history': this.emitRemoveHistory,
                    'completions-close': this.emitCompletionsClose,
                    'completions-open': this.emitCompletionsOpen,
                    'show-completions': $event => { this.isShowCompletions = $event; },
                };
            },
            searchResultsWrapperEventListeners() {
                return {
                    ...mapHandlers(this, commonOfferEventHandlers),
                    ...mapHandlers(this, commonSearchResultsWrapperEventHandlers),
                    'toggle-filters': this.toggleFilters,
                    'toggle-image-picker': args => this.onSearchInputAction('toggle-image-picker', args),
                    'handle-search': () => this.onSearchInputAction('handle-search'),
                };
            },
        },

        watch: {
            'searchState.public': function (state) {
                if (this.localQueryParams && this.localQueryParams.query !== state.query) {
                    this.store.commit('ui/SET_PROPERTY', { key: 'isCategoriesListVisible', value: false });
                    this.store.commit('ui/SET_PROPERTY', { key: 'isFiltersOpened', value: false });
                    this.store.commit('ui/SET_PROPERTY', { key: 'isImageSearchVisible', value: false });
                }
                this.localQueryParams = state ? { ...state } : {};
            },
        },

        beforeCreate() {
            Object.assign(this, { projectName: 'SearchBooster.io' });
            Object.assign(this, { href: 'https://searchbooster.io/' });
        },

        mounted() {
            this.$on('search-input-change', () => {
                this.resetImage();
            });
            this.$on('handle-search', () => {
                this.resetImage();
            });

            this.addCss(this.$configuration.searchResult.topBlock.customCss);
        },

        updated() {
            this.setValueToSignature();
        },

        methods: {
            ...RootComponentMixin.methods,
            ...SearchResultsMixin.methods,
            onLoadLogo() {
                this.logoAccess = false;
            },
            addCss(cssCode) {
                let shDom = document.querySelector('searchbooster-search-popup');
                let style = document.createElement('style');
                if (style.styleSheet) {
                    style.styleSheet.cssText = cssCode;
                } else {
                    style.appendChild(document.createTextNode(cssCode));
                }
                shDom.shadowRoot.appendChild(style);
            },
            onClickOutside(event) {
                if (this.wrapperClickTarget === event.target) {
                    this.handleCloseWidgetCommonActions();
                    this.closeWidgetClick('lossFocus', event);
                }
            },
            onClickCloseButton(event) {
                this.handleCloseWidgetCommonActions();
                this.closeWidgetClick('buttonClick', event);
            },
            handleCloseWidgetCommonActions() {
                this.emitResetQuery();
                this.resetImage();
                this.emitSearchPopupClose();
            },
            closeWidgetClick(clickType, event) {
                this.emitCloseWidgetClick(this.query, clickType, event);
            },
            mousedownClose(event) {
                this.wrapperClickTarget = event.target;
            },
            onToggleCategories(value) {
                const resultValue = value === undefined ? !this.store.state.ui.isCategoriesListVisible : !!value;
                if (resultValue) {
                    this.store.commit('ui/SET_PROPERTY', { key: 'isFiltersOpened', value: false });
                    this.store.commit('ui/SET_PROPERTY', { key: 'isImageSearchVisible', value: false });
                    this.store.commit('ui/SET_PROPERTY', { key: 'isCompletionsVisible', value: false });
                }
                this.store.state.ui.isCategoriesListVisible = resultValue;
                if (resultValue) {
                    this.emitSearchPopupFetchCategories();
                }
            },
            startSearchByImage(baseImage) {
                this.store.commit('base64Image/SET_PROPERTY', baseImage);
                this.store.commit('ui/SET_PROPERTY', { key: 'isCategoriesListVisible', value: false });
                this.store.commit('ui/SET_PROPERTY', { key: 'isFiltersOpened', value: false });
                this.store.commit('ui/SET_PROPERTY', { key: 'isImageSearchVisible', value: false });
            },
            toggleImageSearch(value) {
                this.store.commit('ui/SET_PROPERTY', {
                    key: 'isImageSearchVisible',
                    value: value === undefined ? !this.store.state.ui.isImageSearchVisible : !!value,
                });
                this.store.commit('ui/SET_PROPERTY', { key: 'isImageSearchLoader', value: false });
                this.store.commit('ui/SET_PROPERTY', { key: 'isCategoriesListVisible', value: false });
                this.store.commit('ui/SET_PROPERTY', { key: 'isFiltersOpened', value: false });
                this.store.commit('ui/SET_PROPERTY', { key: 'isCompletionsVisible', value: false });
            },
            toggleVoiceSearch(event, value) {
                const isVoiceSearch = value === undefined ? !this.store.state.ui.isVoiceSearchActive : !!value;

                this.store.commit('ui/SET_PROPERTY', {
                    key: 'isVoiceSearchActive',
                    value: isVoiceSearch,
                });

                this.emitVoiceSearch(isVoiceSearch);

                if (isVoiceSearch) {
                    this.$emit('voice-click', {
                        type: 'voiceClick',
                        event,
                    });
                }
            },
            resetImage() {
                this.store.commit('base64Image/SET_PROPERTY', null);
            },
            onAutocompleteSearch(value) {
                this.emitAutocompleteSearch(value);
            },
            setValueToSignature() {
                if (!this.isShowSignature)
                    return;
                const i18nStr = this.$t('signature', [this.projectName]);
                const preparedValue = i18nStr.replace(this.projectName, '');
                const refsList = i18nStr.indexOf(this.projectName) === 0
                    ? [this.$refs.signatureLeft, this.$refs.signatureRight]
                    : [this.$refs.signatureRight, this.$refs.signatureLeft];
                if (!refsList.some(Boolean))
                    return;
                refsList[0].innerText = this.projectName;
                refsList[0].href = this.href;
                refsList[0].target = '_blank';
                refsList[1].innerText = preparedValue;
            },
            onDenyAgeCheck() {
                if (this.$configuration.features.ageCheckPopupType === 'filter') {
                    this.emitSearchAll();
                } else {
                    this.emitResetQuery();
                    this.emitSearchPopupClose();
                    window.location.href = getCookie('ageCheckPopupRedirectUrl', this.$configuration.ageCheckPopupRedirectUrl);
                }
            },
        },
    };
</script>
